import { Card, CardProps, PageHeader, Space } from 'antd';
import React from 'react';
import classNames from 'classnames';
import './index.scss';

const cx = classNames.bind('./index.scss');

export interface CardLayout extends CardProps {}

const CardLayout = ({
  children,
  bodyStyle,
  style,
  headStyle,
  title,
}: React.PropsWithChildren<CardLayout>): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Card
      className={cx('cardLayout')}
      title={title}
      bordered={false}
      style={style}
      headStyle={{ border: 'none', ...headStyle }}
      bodyStyle={bodyStyle}
    >
      {children}
    </Card>
  );
};

export default CardLayout;
